// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O4w2","tabsBox":"styles_tabsBox__3Oieu","createButton":"styles_createButton__38uWu"};